import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'

import Layout               from './components/Layout'
import HomePage             from './pages/HomePage'
import UnderConstruction    from './pages/UnderConstruction'
import FAQ                  from './pages/FAQ'
import TermsOfService       from './pages/TermsOfService'
import PrivacyPolicy        from './pages/PrivacyPolicy'
import Download             from './pages/Download'
import DeleteAccount, { DataDeletionRedirect } from './pages/DeleteAccount'
import FreeGuide            from './pages/FreeGuide'
import Blog                 from './pages/Blog'
import BlogPost             from './pages/BlogPost'
import About                from './pages/About'

/* Shared page set: served at / (English) and mirrored under /es (Spanish).
   Layout switches the active language based on the /es prefix. */
const pageRoutes = (
  <>
    <Route index element={<HomePage />} />
    <Route path="under-construction" element={<UnderConstruction />} />
    <Route path="download"           element={<Download />} />
    <Route path="faq"                element={<FAQ />} />
    <Route path="terms-of-service"   element={<TermsOfService />} />
    <Route path="privacy-policy"     element={<PrivacyPolicy />} />
    <Route path="delete-account"     element={<DeleteAccount />} />
    <Route path="free-guide"         element={<FreeGuide />} />
    <Route path="about"              element={<About />} />
    <Route path="blog"               element={<Blog />} />
    <Route path="blog/:slug"         element={<BlogPost />} />
    {/* Play Console wants a distinct data-deletion URL; both resolve to one page. */}
    <Route path="data-deletion"      element={<DataDeletionRedirect />} />
  </>
)

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          {pageRoutes}
          <Route path="es">{pageRoutes}</Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App
